import { gql } from '@apollo/client'

export const UPDATE_USER_LICENSE_PLATE = gql`
    mutation update_user_license_plate($request: UpdateUserLicensePlateRequest!) {
        update_user_license_plate(request: $request) {
            success
        }
    }
`

// $plate: String!, $country: String!
